import React from 'react';

import AccordionsShowcase from './AccordionsShowcase';
import accordionsSet from './constants/accordionsSet';

const Accordions = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          accordionsSet.map((group, i) => (
            <li key={`accordion-showcase-${i}`}>
              <AccordionsShowcase {...group} />
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default Accordions;



// WEBPACK FOOTER //
// ./src/containers/components/Accordion/Accordions.js